import { createContext } from 'react';
import { IUnit } from './models';

interface IUnitContext {
  getUnitPath: () => Array<IUnit> | undefined;
}

export const UnitContext = createContext<IUnitContext>({
  getUnitPath: () => [],
});

interface IUnitGlobalContext {}

export const UnitGlobalContext = createContext<IUnitGlobalContext>({});
